import { render, staticRenderFns } from "./InboundFollowUpNotification.vue?vue&type=template&id=233e6056&scoped=true&"
import script from "./InboundFollowUpNotification.vue?vue&type=script&lang=js&"
export * from "./InboundFollowUpNotification.vue?vue&type=script&lang=js&"
import style0 from "./InboundFollowUpNotification.vue?vue&type=style&index=0&id=233e6056&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e6056",
  null
  
)

export default component.exports